import { render } from "./PromopushkaComments.vue?vue&type=template&id=f70444c2"
import script from "./PromopushkaComments.vue?vue&type=script&lang=js"
export * from "./PromopushkaComments.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__